export default "__VITE_ASSET__DVy4sjaP__"